import { useTranslation } from 'react-i18next';
import { Gender } from '../../participantEnums';

export const useGenders = () => {
  const { t } = useTranslation('common');
  return [
    {
      value: Gender.MALE,
      label: t('participants.enums.gender.MALE'),
    },
    {
      value: Gender.FEMALE,
      label: t('participants.enums.gender.FEMALE'),
    },
    {
      value: Gender.NON_BINARY,
      label: t('participants.enums.gender.NON_BINARY'),
    },
  ];
};
